import React from 'react';

import { useIntl } from 'react-intl';

import VerticalBarChart from 'src/features/statistic/components/chart/VerticalBarChart';
import { statisticMessages } from 'src/features/statistic/utils/messages';
import { useTitleStore } from 'src/stores/useTitleStore';
import dayjs from 'dayjs';

export default function GatewayStatistics() {
    const { formatMessage } = useIntl();
    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(statisticMessages.gatewayStatistics));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <div className="grid min-h-200 flex-1 grid-cols-3 gap-6">
            <VerticalBarChart date={dayjs()} />
            <VerticalBarChart date={dayjs().subtract(1, 'day')} />
            <VerticalBarChart date={dayjs().subtract(2, 'day')} />
        </div>
    );
}
